// Marketplace is restricted to a single user for now. Centralised here so the
// nav item, the page route guards and the in-task "Find suppliers" shortcut
// all agree. Widen MARKETPLACE_EMAILS to open it up later.
export const MARKETPLACE_EMAILS = ["faruk@yerli.cc"];

export const canSeeMarketplace = (user) =>
  !!user && (user.is_admin || MARKETPLACE_EMAILS.includes((user.email || "").toLowerCase()));

// Who can manage the marketplace (review/approve applications, edit suppliers
// & categories): the global admin OR a marketplace-allowed user (e.g. faruk).
export const canManageMarketplace = (user) =>
  !!user && (user.is_admin || canSeeMarketplace(user));
